module.exports = __webpack_public_path__ + "img/ROLLING_HILLS-AnneDigges.32a326ae.svg";